import {
  FileDown,
  FileOutput,
  Filter,
  Globe,
  Languages,
  Sparkles,
} from "lucide-react";
import { getLanguageByCode } from "@/lib/i18n/languages";

// Each setting: its field, how On reads (More Solutions is stored as a hide).
export const COMPANY_FEATURE_SETTING_ROWS = [
  {
    field: "gtoolExportEnabled",
    titleKey: "company_feature_gtool_export",
    descriptionKey: "company_feature_gtool_export_desc",
    Icon: FileDown,
    kind: "boolean",
  },
  {
    field: "hideMoreSolutions",
    titleKey: "company_feature_more_solutions",
    descriptionKey: "company_feature_more_solutions_desc",
    Icon: Sparkles,
    kind: "boolean",
    inverted: true,
  },
  {
    field: "reportFrameworksFilterRequired",
    titleKey: "company_feature_frameworks_required",
    descriptionKey: "company_feature_frameworks_required_desc",
    Icon: Filter,
    kind: "boolean",
  },
  {
    field: "reportExportFormats",
    titleKey: "company_feature_report_exports",
    descriptionKey: "company_feature_report_exports_desc",
    Icon: FileOutput,
    kind: "formats",
  },
  {
    field: "defaultLanguage",
    titleKey: "company_feature_default_language",
    descriptionKey: "company_feature_default_language_desc",
    Icon: Languages,
    kind: "language",
  },
  {
    field: "languageDetectionEnabled",
    titleKey: "company_feature_language_detection",
    descriptionKey: "company_feature_language_detection_desc",
    Icon: Globe,
    kind: "boolean",
  },
];

export const FORMAT_LABEL_KEYS = {
  word: "company_feature_format_word",
  pdf: "company_feature_format_pdf",
  csv: "company_feature_format_csv",
};

/** How a value reads for the admin (also used by the summary step). */
export const describeFeatureSettingValue = (row, value, t) => {
  if (row.kind === "boolean") {
    const on = row.inverted ? value !== true : value === true;
    return on ? t("company_feature_on") : t("company_feature_off");
  }
  if (row.kind === "formats") {
    const formats = Array.isArray(value) ? value : [];
    return formats.length
      ? formats.map((format) => t(FORMAT_LABEL_KEYS[format])).join(", ")
      : t("company_feature_formats_none");
  }
  return getLanguageByCode(value)?.nativeName || value;
};

/** The control's current reading, "Host default" included. */
export const describeFeatureSettingState = (row, state, defaults, t) => {
  if (state.mode === "explicit") {
    return describeFeatureSettingValue(row, state.value, t);
  }
  return defaults
    ? t("company_feature_host_default_value", {
        value: describeFeatureSettingValue(row, defaults[row.field], t),
      })
    : t("company_feature_host_default");
};

// Id of a setting's visible title, which names its control (screen readers).
export const featureSettingTitleId = (field) =>
  `company-feature-${field}-title`;
